export default {
	save: 'Зміни успішно збережені',
	error: 'Помилка. Зверніться в службу підтримки',
	'old password was incorrect': 'Старий пароль був неправильним',
	templateDuplicated: 'Шаблон успішно продубльований',

}